module.exports = __webpack_public_path__ + "static/media/issues-with-coworkers.27db08d6.jpg";